import { connect } from 'react-redux';
import { getParticipateForm, toggleParticipateForm } from 'project/ducks/form';
import ProjectParticipateButton from 'project/components/project_participate_button';

function mapSubmitStateToProps(state) {
  return {
    formOpen: getParticipateForm(state).formOpen
  };
}

export default connect(mapSubmitStateToProps, { toggleParticipateForm })(ProjectParticipateButton);
